{
  "customer-selection-form": {
    "buttons": {
      "close": "Zavřít",
      "create_new_customer_profile": "Vytvořit nový",
      "select": "Vyberte",
      "selected": "Vybrané stránky"
    },
    "text": {
      "search_field_label": "Vyhledávání podle telefonního čísla, e-mailu nebo jména",
      "title": "Výběr zákazníků"
    }
  }
}
